import NgrxAuth from '../../auth/Auth'
import { CALL_API } from '../../util/RBRestMiddleware'

export const UNCLAIMED_HCSAEXPENSE_LOADING = 'UNCLAIMED_HCSAEXPENSE_LOADING'
export const UNCLAIMED_HCSAEXPENSE_SUCCESS = 'UNCLAIMED_HCSAEXPENSE_SUCCESS'
export const UNCLAIMED_HCSAEXPENSE_FAILED = 'UNCLAIMED_HCSAEXPENSE_FAILED'

export const EXPENSETYPES_LOADING = 'EXPENSETYPES_LOADING'
export const EXPENSETYPES_SUCCESS = 'EXPENSETYPES_SUCCESS'
export const EXPENSETYPES_FAILED = 'EXPENSETYPES_FAILED'

export const BENEFIT_TYPES_LOADING = 'BENEFIT_TYPES_LOADING'
export const BENEFIT_TYPES_SUCCESS = 'BENEFIT_TYPES_SUCCESS'
export const BENEFIT_TYPES_FAILED = 'BENEFIT_TYPES_FAILED'

export const CLEAR_BENEFIT_TYPES = 'CLEAR_BENEFIT_TYPES'

export const QUANTITY_TYPES_LOADING = 'QUANTITY_TYPES_LOADING'
export const QUANTITY_TYPES_SUCCESS = 'QUANTITY_TYPES_SUCCESS'
export const QUANTITY_TYPES_FAILED = 'QUANTITY_TYPES_FAILED'

export const PROVINCES_LOADING = 'PROVINCES_LOADING'
export const PROVINCES_SUCCESS = 'PROVINCES_SUCCESS'
export const PROVINCES_FAILED = 'PROVINCES_FAILED'

export const HCSA_FILTER_CHANGE = 'HCSA_FILTER_CHANGE'
export const HCSA_PAGE_CHANGE = 'HCSA_PAGE_CHANGE'
export const UPDATE_PERIOD_TOTALS = 'UPDATE_PERIOD_TOTALS'
export const CLEAR_TOTALS = 'CLEAR_TOTALS'

export const DIN_LOADING = 'DIN_LOADING'
export const DIN_SUCCESS = 'DIN_SUCCESS'
export const DIN_FAILED = 'DIN_FAILED'

// HCSA unpaid expenses
export const fetchUnclaimedHCSAExpenses = (obj) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/healthCareSpendingAccountUnpaidExpenses/${obj.name}/${obj.type}/${obj.start}/${obj.end}/20/${obj.pageNum}`,
        prefix: 'UNCLAIMED_HCSAEXPENSE'
      }
    })
  }
}

export const setFilters = (filters) => {
  return {
    type: 'HCSA_FILTER_CHANGE',
    filters
  }
}
export const changePage = (pageNum = 1) => {
  return {
    type: 'HCSA_PAGE_CHANGE',
    pageNum
  }
}
export const updatePeriodTotals = (newTotal) => {
  return {
    type: 'UPDATE_PERIOD_TOTALS',
    newTotal
  }
}
export const clearPeriodTotals = () => {
  return {
    type: CLEAR_TOTALS
  }
}

// get Type of Expenses
export const fetchExpenseTypes = (type) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/expenseServices`,
        prefix: 'EXPENSETYPES',
        query: type,
        method: 'post'
      }
    })
  }
}
// benefit types
export const fetchBenefitTypes = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/benefitTypes`,
        prefix: 'BENEFIT_TYPES'
      }
    })
  }
}

// drug quantity types
export const fetchQuantityTypes = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/getDrugQuantityTypes`,
        prefix: 'QUANTITY_TYPES'
      }
    })
  }
}

export const fetchProvinces = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/userProfile/getProvinceList',
        prefix: 'PROVINCES'
      }
    })
  }
}

export const SearchDIN = (dinNum, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/submitaclaim/${NgrxAuth.memberId}/searchDrugByDrugIdentNumber/${dinNum}`,
        prefix: 'DIN',
        onSuccess,
        onError
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/submitExpenseActions.js